import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppMaterialModule } from '../app-material/app-material.module';
import { ChartsModule } from 'ng2-charts';


import { HomeSaguicontrolComponent } from './home-saguicontrol/home-saguicontrol.component';

import { HomeSaguicontrolService } from './shared/home-saguicontrol.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { HomeComponent } from './home/home.component';

import { HomeService } from './shared/home.service';
import { CardModule } from '../Components/card/card.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatProgressBarModule,
        CardModule,
        ReactiveFormsModule,
        AppMaterialModule,
        ChartsModule
    ],
    declarations: [
        HomeSaguicontrolComponent,
        HomeComponent
    ],
    providers: [
        HomeSaguicontrolService,
        HomeService

    ]
})

export class HomeModule { }
